import {TaxpayerNode, TaxpayerRelationshipType} from './types';

export const defineActivePath = (root: TaxpayerNode, direction: TaxpayerRelationshipType) => {
    let maxSum = 0;
    let selectedPath: TaxpayerNode[] = [];
    const relationshipKey =
        direction === 'SALE' ? 'relationshipFromParent' : 'relationshipToParent';

    const traverse = (
        node: TaxpayerNode,
        path: TaxpayerNode[],
        sum: number,
        seenRelationships: Set<string>,
    ) => {
        node.isActive = false;
        const relationship = node[relationshipKey];
        const isNewRelationship = relationship && !seenRelationships.has(relationship.elementId);
        const value =
            sum + (isNewRelationship ? Number(relationship.properties.taxAmount || 0) : 0);

        if (value > maxSum) {
            maxSum = value;
            selectedPath = path;
        }

        const nextRelationships = new Set(seenRelationships);
        if (relationship) nextRelationships.add(relationship.elementId);
        node.children?.forEach((child) =>
            traverse(child, [...path, child], value, nextRelationships),
        );
    };

    traverse(root, [root], 0, new Set());
    selectedPath.forEach((node) => {
        node.isActive = true;
    });
};
